import React from 'react'
import type { ContactInfoProps } from '@/features/enrollment'
import { formatPhone } from '@/shared/utils'

export default function PFASContactInfo({ enrollmentData, updateEnrollmentData, errors }: ContactInfoProps) {
  return (
    <>
      {/* Email Address */}
      <div>
        <label className="block text-sm font-medium text-accent-700 mb-2">
          Email Address <span className="text-red-500">*</span>
        </label>
        <input 
          type="email" 
          name="injuredPartyEmail"
          className={`input-field ${errors.injuredPartyEmail ? 'border-red-500' : ''}`} 
          placeholder="Enter email address" 
          value={enrollmentData.injuredPartyEmail || ''} 
          onChange={(e) => updateEnrollmentData('injuredPartyEmail', e.target.value)}
        />
        {errors.injuredPartyEmail && (
          <p className="mt-1 text-sm text-red-600">{errors.injuredPartyEmail}</p>
        )}
      </div>

      {/* Address */}
      <div>
        <label className="block text-sm font-medium text-accent-700 mb-2">
          Address <span className="text-red-500">*</span>
        </label>
        <div className="space-y-3">
          <input 
            type="text" 
            name="injuredPartyAddressLine1"
            className={`input-field ${errors.injuredPartyAddressLine1 ? 'border-red-500' : ''}`} 
            placeholder="Address Line 1" 
            value={enrollmentData.injuredPartyAddressLine1 || ''} 
            onChange={(e) => updateEnrollmentData('injuredPartyAddressLine1', e.target.value)} 
          />
          {errors.injuredPartyAddressLine1 && (
            <p className="mt-1 text-sm text-red-600">{errors.injuredPartyAddressLine1}</p>
          )}
          <input 
            type="text" 
            className="input-field" 
            placeholder="Address Line 2 (optional)" 
            value={enrollmentData.injuredPartyAddressLine2 || ''} 
            onChange={(e) => updateEnrollmentData('injuredPartyAddressLine2', e.target.value)} 
          />
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <input 
              type="text" 
              className={`input-field ${errors.injuredPartyCity ? 'border-red-500' : ''}`} 
              placeholder="City" 
              value={enrollmentData.injuredPartyCity || ''} 
              onChange={(e) => updateEnrollmentData('injuredPartyCity', e.target.value)} 
            />
            <select 
              className={`input-field ${errors.injuredPartyState ? 'border-red-500' : ''}`} 
              value={enrollmentData.injuredPartyState || ''} 
              onChange={(e) => updateEnrollmentData('injuredPartyState', e.target.value)}
            >
              <option value="">Select State</option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
            <input 
              type="text" 
              className={`input-field ${errors.injuredPartyZipCode ? 'border-red-500' : ''}`} 
              placeholder="ZIP Code" 
              maxLength={5}
              value={enrollmentData.injuredPartyZipCode || ''} 
              onChange={(e) => updateEnrollmentData('injuredPartyZipCode', e.target.value.replace(/\D/g, '').slice(0, 5))} 
            />
          </div>
          {(errors.injuredPartyCity || errors.injuredPartyState || errors.injuredPartyZipCode) && (
            <div className="mt-1">
              {errors.injuredPartyCity && <p className="text-sm text-red-600">{errors.injuredPartyCity}</p>}
              {errors.injuredPartyState && <p className="text-sm text-red-600">{errors.injuredPartyState}</p>}
              {errors.injuredPartyZipCode && <p className="text-sm text-red-600">{errors.injuredPartyZipCode}</p>}
            </div>
          )}
        </div>
      </div>

      {/* Phone Number */}
      <div>
        <label className="block text-sm font-medium text-accent-700 mb-2">
          Phone Number <span className="text-red-500">*</span>
        </label>
        <input 
          type="tel" 
          name="phoneNumber"
          className={`input-field ${errors.phoneNumber ? 'border-red-500' : ''}`} 
          placeholder="(555) 555-5555" 
          value={enrollmentData.phoneNumber || ''} 
          onChange={(e) => updateEnrollmentData('phoneNumber', formatPhone(e.target.value))}
        />
        {errors.phoneNumber && (
          <p className="mt-1 text-sm text-red-600">{errors.phoneNumber}</p>
        )}
      </div>
    </>
  )
}
